import { instance } from "libs/api";
import { DirectUploadMedia } from "libs/directUpload";

export interface VariantSummary {
  id: string;
  productId: string;
  name: string;
  preview?: DirectUploadMedia | null;
  compressedPreview?: DirectUploadMedia | null;
  product?: { categoryId: string };
}

export const requestGetVariantsByIds = async (
  ids: string[]
): Promise<VariantSummary[]> => {
  return await instance.get(`admin/products/variants/by-ids/${ids.join(",")}`);
};
